module.exports = __webpack_public_path__ + "img/1493353306.422fe76d.jpg";